import { useMutation } from 'react-query';

import { deleteStoredFilterBulkAssignToUser as mutationFn } from 'api/endPoints/deleteStoredFilterBulkAssignToUser';

export const useMutationDeleteStoredFilterBulkAssignToUser = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id: string;
    contractId: number;
}
